import { CardActionArea, Box, CircularProgress, Typography } from "@mui/material";
import AddAPhotoIcon from "@mui/icons-material/AddAPhoto";
import ImageNotSupportedIcon from "@mui/icons-material/ImageNotSupported";
import type { ReactNode } from "react";

const fullSurface = {
  position: "absolute",
  top: 0,
  bottom: 0,
  left: 0,
  right: 0,
  m: "auto",
};

const square = {
  width: "100%",
  height: 0,
  pb: "100%",
};

interface PhotoImageInnerCardProps {
  base64String?: string | null;
  isLoading?: boolean;
  readOnly?: boolean;
}

function PhotoImageInnerCard({
  base64String,
  isLoading = false,
  readOnly = false,
}: Readonly<PhotoImageInnerCardProps>): ReactNode {
  if (isLoading) {
    return <CircularProgress disableShrink sx={fullSurface} />;
  }

  if (!readOnly && base64String == null) {
    return (
      <Box sx={square}>
        <AddAPhotoIcon color="secondary" sx={{ ...fullSurface, fontSize: "60px" }} />
      </Box>
    );
  }
  if (readOnly && base64String === null) {
    return (
      <Box sx={square}>
        <ImageNotSupportedIcon color="error" sx={{ ...fullSurface, fontSize: "60px" }} />
        <Typography
          sx={{
            position: "absolute",
            bottom: 0,
            left: 0,
            right: 0,
            textAlign: "center",
            p: 1,
          }}>
          L'image n'a pas pu être chargée
        </Typography>
      </Box>
    );
  }

  return null;
}

interface PhotoImageProps {
  base64String?: string | null;
  isLoading?: boolean;
  readOnly?: boolean;
  onClick: () => void;
}

function PhotoImage({
  base64String,
  isLoading = false,
  readOnly = false,
  onClick,
}: Readonly<PhotoImageProps>): ReactNode {
  const squareWithImage = {
    ...square,
    backgroundImage: `url("${base64String}")`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
  };

  return (
    <CardActionArea
      onClick={onClick}
      sx={{
        ...(base64String != null && base64String !== "" ? { cursor: "zoom-in" } : {}),
        ...(isLoading ? { cursor: "progress" } : {}),
      }}>
      <Box sx={squareWithImage}>
        <PhotoImageInnerCard
          base64String={base64String}
          isLoading={isLoading}
          readOnly={readOnly}
        />
      </Box>
    </CardActionArea>
  );
}

export default PhotoImage;
